import { render, staticRenderFns } from "./ChooseAppPlatform.vue?vue&type=template&id=164d2344&scoped=true"
import script from "./ChooseAppPlatform.vue?vue&type=script&lang=js"
export * from "./ChooseAppPlatform.vue?vue&type=script&lang=js"
import style0 from "./ChooseAppPlatform.vue?vue&type=style&index=0&id=164d2344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d2344",
  null
  
)

export default component.exports